import axios from 'axios';

import RubrosTabla from '../types/RubrosTabla';


async function GuardarRubro(prmRubro: RubrosTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_rubro"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "rubro": {
                "id": prmRubro.id,
                "rubro": prmRubro.rubro,
                "habilitado": prmRubro.habilitado,
                "fch_modi": prmRubro.fecha_modificacion,
                "dado_de_baja": prmRubro.dado_de_baja,
                "fch_baja": prmRubro.fecha_baja
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarRubro;